import type { AutonomyLevel } from '@/types/dashboard'

interface Props {
  healthLabel: string
  healthOk: boolean
  aiLabel: string
  outboxLabel: string
  autonomy: AutonomyLevel
  onAutonomy: (level: AutonomyLevel) => void
  onHelp: () => void
  userLabel?: string
  onSignIn?: () => void
  onSignOut?: () => void
}

export function Topbar({
  healthLabel,
  healthOk,
  aiLabel,
  outboxLabel,
  autonomy,
  onAutonomy,
  onHelp,
  userLabel,
  onSignIn,
  onSignOut
}: Props) {
  return (
    <header className="topbar" role="banner">
      <div className="brand">
        <div className="brand-mark">
          Flow<em>line</em>
        </div>
        <div className="brand-sub">ops console</div>
      </div>
      <div className="top-actions">
        <span className={`chip dot ${healthOk ? 'live' : 'warn'} hide-sm`}>{healthLabel}</span>
        <span className="chip hide-sm">{aiLabel}</span>
        <span className="chip hide-sm">{outboxLabel}</span>
        {userLabel ? (
          <span className="chip hide-sm" title={userLabel}>
            {userLabel}
          </span>
        ) : null}
        <select
          className="select"
          aria-label="Autonomy level"
          value={autonomy}
          onChange={(e) => onAutonomy(e.target.value as AutonomyLevel)}
        >
          <option value="off">off</option>
          <option value="suggest">suggest</option>
          <option value="auto_apply_safe">auto-safe</option>
        </select>
        {userLabel ? (
          <button className="icon-btn" type="button" aria-label="Sign out" onClick={onSignOut}>
            ⎋
          </button>
        ) : (
          <button className="icon-btn" type="button" aria-label="Sign in" onClick={onSignIn}>
            ⌂
          </button>
        )}
        <button className="icon-btn" type="button" aria-label="Keyboard shortcuts" onClick={onHelp}>
          ?
        </button>
      </div>
    </header>
  )
}
